import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Form, FormSubmit, FormText } from '../../../../../../shared/form/form'
import { useApiFormNodeTemplate } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { AssetList } from '../../common/assets/asset-list'
import { TemplateMenu } from '../../common/menu/node-actions'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { FormJsonEditorStr } from '../../../../../../shared/form/form-control/form-json-editor-str'
import { useDataContext } from '../data-context'
import { NodeCourseVersionList } from '../../common/assets/node-course-version-list'

export const NodeTemplateEditSys = ({ parentURL, nodeID }) => {
  const { url } = useRouteMatch()

  const dataContext = useDataContext()

  const apiFormTemplate = useApiFormNodeTemplate()

  const handleMatch = () => apiFormTemplate.get(nodeID)

  const title = useMemo(() => apiFormTemplate.form.name, [apiFormTemplate.form])

  const handleSubmit = async data => {
    await apiFormTemplate.put(data.id, data)
    dataContext.reload()
  }

  const HeaderMenu = () => <TemplateMenu place="header" url={parentURL} node={apiFormTemplate.form} />

  return (
    <React.Fragment>
      {/* Assets and Version metadata are the node's menu pages, mounted under
          this address: they are no pages of this one's (audit F16). */}
      <BreadcrumbView Icon={IconEdit} text="Sys admin edit" onMatch={handleMatch} notOver={['assets', 'versions']}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          <Form state={apiFormTemplate.form} onSubmit={handleSubmit}>
            <FormText label="name" name="name" required />
            <FormJsonEditorStr label="metadata" name="metadata" />
            <FormSubmit text="update" />
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/assets`}>
        <AssetList parentURL={url} nodeID={nodeID} />
      </Route>

      <Route path={`${url}/versions`}>
        <NodeCourseVersionList parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
